module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "id": "section"
    }
  }, [_c('el-row', {
    staticClass: "statusRowWhite"
  }, [_c('div', {
    staticClass: "RowChild"
  }, [_vm._v("\n    \t\t\t  公司名称：   \n\t\t\t"), _c('el-select', {
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "请选择公司名称"
    },
    on: {
      "change": _vm.getList
    },
    model: {
      value: (_vm.pdata.cp_company_id),
      callback: function($$v) {
        _vm.$set(_vm.pdata, "cp_company_id", $$v)
      },
      expression: "pdata.cp_company_id"
    }
  }, _vm._l((_vm.companyList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "RowChild"
  }, [_vm._v("\n       结算期：   \n\t     "), _c('el-date-picker', {
    attrs: {
      "type": "month",
      "format": "yyyyMM",
      "value-format": "yyyyMM",
      "placeholder": "选择月"
    },
    on: {
      "change": _vm.getList
    },
    model: {
      value: (_vm.pdata.d_date),
      callback: function($$v) {
        _vm.$set(_vm.pdata, "d_date", $$v)
      },
      expression: "pdata.d_date"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "RowChild"
  }, [_vm._v("\n    \t 分成方式：   \n\t\t "), _c('el-select', {
    staticClass: "xs24",
    attrs: {
      "placeholder": "请选择账单类型"
    },
    on: {
      "change": _vm.getList
    },
    model: {
      value: (_vm.pdata.bill_type),
      callback: function($$v) {
        _vm.$set(_vm.pdata, "bill_type", $$v)
      },
      expression: "pdata.bill_type"
    }
  }, [_c('el-option', {
    key: "1",
    attrs: {
      "label": "原生分成账单",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    key: "2",
    attrs: {
      "label": "利润分成账单",
      "value": "2"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "RowChild"
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": _vm.batchProduct
    }
  }, [_vm._v("导入")])], 1), _vm._v(" "), _c('div', {
    staticClass: "RowChild"
  }, [_c('el-button', {
    attrs: {
      "size": "medium",
      "type": "text"
    },
    on: {
      "click": _vm.downloadTemp
    }
  }, [_vm._v("导入模板下载")])], 1), _vm._v(" "), _c('div', {
    staticClass: "RowChild"
  }, [(_vm.pdata.cp_company_id != '' && _vm.plist.length > 0) ? _c('el-button', {
    attrs: {
      "size": "medium",
      "icon": "el-icon-download",
      "type": "primary"
    },
    on: {
      "click": _vm.getBillList
    }
  }, [_vm._v("导出预览")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "RowChild"
  }, [_c('el-button', {
    attrs: {
      "size": "medium",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push('/billCpData/summary')
      }
    }
  }, [_vm._v("分成汇总")])], 1)]), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "padding": "15px",
      "background": "#fff"
    }
  }, [_c('el-table', {
    staticClass: "demo-table",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.plist,
      "stripe": "",
      "row-key": "id",
      "show-summary": "",
      "summary-method": _vm.getSummaries
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "bill_cp_data_id",
      "label": "ID",
      "min-width": "50px",
      "width": "50",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "date",
      "label": "结算周期",
      "min-width": "140px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "company_name",
      "label": "公司名称",
      "align": "center",
      "min-width": "100px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "游戏名称",
      "align": "center",
      "min-width": "100px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "appid",
      "label": "appid",
      "align": "center",
      "min-width": "140px"
    }
  }), _vm._v(" "), (_vm.pdata.bill_type == 1) ? _c('el-table-column', {
    attrs: {
      "prop": "other_cost",
      "label": "其他费用",
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "origin_income",
      "label": "原生收入",
      "align": "center"
    }
  }), _vm._v(" "), (_vm.pdata.bill_type == 2) ? _c('el-table-column', {
    attrs: {
      "prop": "sell_income",
      "label": "分发收入",
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pdata.bill_type == 2) ? _c('el-table-column', {
    attrs: {
      "prop": "export_cost",
      "label": "导量成本",
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pdata.bill_type == 2) ? _c('el-table-column', {
    attrs: {
      "prop": "profit",
      "label": "利润",
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "divide_per",
      "label": "结算比例",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "tax_point",
      "label": "应扣税点",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.tax_point) + "%")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "total_cost",
      "label": "结算金额",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": "操作",
      "min-width": "50px",
      "width": "400",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "medium",
            "type": "primary",
            "icon": "el-icon-edit"
          },
          on: {
            "click": function($event) {
              return _vm.updateCPBillData(scope.row)
            }
          }
        }, [_vm._v("更新账单")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "medium"
          }
        }, [_vm._v("明细")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "medium"
          },
          on: {
            "click": function($event) {
              return _vm.editRemark(scope.row)
            }
          }
        }, [_vm._v("备注")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "medium"
          },
          on: {
            "click": function($event) {
              return _vm.openDealy(scope.row.bill_cp_data_id)
            }
          }
        }, [_vm._v("操作日志")])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "padding": "15px",
      "background": "#fff"
    }
  }, _vm._l((_vm.plist), function(item) {
    return (item.remark != '' && item.remark != '') ? _c('el-col', {
      attrs: {
        "span": 24
      }
    }, [_vm._v("\n    \t\t" + _vm._s(item.remark) + "\n    \t\t\n    \t")]) : _vm._e()
  }), 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.isAdd ? '结算' : '结算',
      "visible": _vm.billDialog,
      "top": "5vh",
      "width": _vm.pdata.bill_type == 1 ? '950px' : '1150px',
      "custom-class": "dialog",
      "close-on-click-modal": false,
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.billDialog = $event
      }
    }
  }, [_c('el-form', {
    ref: "ruleForm",
    attrs: {
      "rules": _vm.rules,
      "label-width": _vm.formLabelWidth
    }
  }, [_c('div', {
    staticClass: "el-table demo-table el-table--fit el-table--striped el-table--border el-table--group el-table--enable-row-hover el-table--enable-row-transition",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "el-table__header-wrapper"
  }, [_c('table', {
    staticClass: "el-table__header",
    style: (_vm.pdata.bill_type == 1 ? 'width: 900px;' : 'width:1100px'),
    attrs: {
      "cellspacing": "0",
      "cellpadding": "0",
      "border": "0",
      "id": "ta"
    }
  }, [(_vm.pdata.bill_type == 1) ? _c('colgroup', [_c('col', {
    attrs: {
      "name": "el-table_3_column_28_column_29",
      "width": "145"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "name": "el-table_3_column_28_column_30",
      "width": "100"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "name": "el-table_3_column_28_column_31",
      "width": "155"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "name": "el-table_3_column_28_column_32",
      "width": "70"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "name": "el-table_3_column_28_column_33",
      "width": "110"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "name": "el-table_3_column_28_column_34",
      "width": "110"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "name": "el-table_3_column_28_column_35",
      "width": "105"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "name": "el-table_3_column_28_column_36",
      "width": "105"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.pdata.bill_type == 2) ? _c('colgroup', [_c('col', {
    attrs: {
      "name": "el-table_3_column_28_column_29",
      "width": "145"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "name": "el-table_3_column_28_column_30",
      "width": "155"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "name": "el-table_3_column_28_column_31",
      "width": "160"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "name": "el-table_3_column_28_column_32",
      "width": "90"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "name": "el-table_3_column_28_column_33",
      "width": "110"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "name": "el-table_3_column_28_column_34",
      "width": "110"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "name": "el-table_3_column_28_column_35",
      "width": "105"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "name": "el-table_3_column_28_column_36",
      "width": "75"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "name": "el-table_3_column_28_column_36",
      "width": "60"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "name": "el-table_3_column_28_column_36",
      "width": "90"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.pdata.bill_type == 1) ? _c('thead', {
    staticClass: "is-group has-gutter"
  }, [_c('tr', {}, [_c('td', {
    staticClass: "el-table_3_column_28  is-center  ",
    attrs: {
      "colspan": "8",
      "rowspan": "1"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("产品结算对账单")])])]), _vm._v(" "), _c('tr', {}, [_c('td', {
    staticClass: "el-table_3_column_28  is-right  ",
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "colspan": "8",
      "rowspan": "1"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("结算单编号：" + _vm._s(_vm.bill_no))])])]), _vm._v(" "), _c('tr', {}, [_c('th', {
    staticClass: "el-table_3_column_28_column_29  is-center   is-leaf",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("结算周期")])]), _vm._v(" "), _c('th', {
    staticClass: "el-table_3_column_28_column_30  is-center   is-leaf",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("游戏名称")])]), _vm._v(" "), _c('th', {
    staticClass: "el-table_3_column_28_column_31  is-center   is-leaf",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("appid")])]), _vm._v(" "), _c('th', {
    staticClass: "el-table_3_column_28_column_32  is-center   is-leaf",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("其他费用")])]), _vm._v(" "), _c('th', {
    staticClass: "el-table_3_column_28_column_33  is-center   is-leaf",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("原生收入/利润")])]), _vm._v(" "), _c('th', {
    staticClass: "el-table_3_column_28_column_34  is-center   is-leaf",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("结算比例")])]), _vm._v(" "), _c('th', {
    staticClass: "el-table_3_column_28_column_35  is-center   is-leaf",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("应扣税点")])]), _vm._v(" "), _c('th', {
    staticClass: "el-table_3_column_28_column_36  is-center   is-leaf",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("结算金额")])])])]) : _vm._e(), _vm._v(" "), (_vm.pdata.bill_type == 2) ? _c('thead', {
    staticClass: "is-group has-gutter"
  }, [_c('tr', {}, [_c('td', {
    staticClass: "el-table_3_column_28  is-center  ",
    attrs: {
      "colspan": "10",
      "rowspan": "1"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("产品结算对账单")])])]), _vm._v(" "), _c('tr', {}, [_c('td', {
    staticClass: "el-table_3_column_28  is-right  ",
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "colspan": "10",
      "rowspan": "1"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("结算单编号：" + _vm._s(_vm.bill_no))])])]), _vm._v(" "), _c('tr', {}, [_c('th', {
    staticClass: "el-table_3_column_28  is-left  ",
    attrs: {
      "colspan": "10",
      "rowspan": "1"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("结算单明细:")])])]), _vm._v(" "), _c('tr', {}, [_c('th', {
    staticClass: "el-table_3_column_28_column_29  is-center   is-leaf",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("结算周期")])]), _vm._v(" "), _c('th', {
    staticClass: "el-table_3_column_28_column_30  is-center   is-leaf",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("游戏名称")])]), _vm._v(" "), _c('th', {
    staticClass: "el-table_3_column_28_column_31  is-center   is-leaf",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("appid")])]), _vm._v(" "), _c('th', {
    staticClass: "el-table_3_column_28_column_32  is-center   is-leaf",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("原生收入")])]), _vm._v(" "), _c('th', {
    staticClass: "el-table_3_column_28_column_33  is-center   is-leaf",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("分发收入")])]), _vm._v(" "), _c('th', {
    staticClass: "el-table_3_column_28_column_34  is-center   is-leaf",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("导量成本")])]), _vm._v(" "), _c('th', {
    staticClass: "el-table_3_column_28_column_35  is-center   is-leaf",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("利润")])]), _vm._v(" "), _c('th', {
    staticClass: "el-table_3_column_28_column_36  is-center   is-leaf",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("结算比例")])]), _vm._v(" "), _c('th', {
    staticClass: "el-table_3_column_28_column_36  is-center   is-leaf",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("税点")])]), _vm._v(" "), _c('th', {
    staticClass: "el-table_3_column_28_column_36  is-center   is-leaf",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("结算金额")])])])]) : _vm._e(), _vm._v(" "), _c('tbody', {
    staticClass: "el-table__body"
  }, [_vm._l((_vm.billList), function(item, index) {
    return (_vm.pdata.bill_type == 1) ? _c('tr', {
      staticClass: "el-table__row",
      class: index % 2 == 1 ? 'el-table__row--striped' : ''
    }, [_c('td', {
      staticClass: "el-table_3_column_28_column_29 is-center ",
      attrs: {
        "rowspan": "1",
        "colspan": "1"
      }
    }, [_c('div', {
      staticClass: "cell"
    }, [_c('span', [_vm._v(_vm._s(item.date))])])]), _vm._v(" "), _c('td', {
      staticClass: "el-table_3_column_28_column_30 is-center ",
      attrs: {
        "rowspan": "1",
        "colspan": "1"
      }
    }, [_c('div', {
      staticClass: "cell"
    }, [_vm._v(_vm._s(item.name))])]), _vm._v(" "), _c('td', {
      staticClass: "el-table_3_column_28_column_31 is-center ",
      attrs: {
        "rowspan": "1",
        "colspan": "1"
      }
    }, [_c('div', {
      staticClass: "cell"
    }, [_vm._v(_vm._s(item.appid))])]), _vm._v(" "), _c('td', {
      staticClass: "el-table_3_column_28_column_32 is-center ",
      attrs: {
        "rowspan": "1",
        "colspan": "1"
      }
    }, [_c('div', {
      staticClass: "cell"
    }, [_vm._v(_vm._s(item.other_cost))])]), _vm._v(" "), _c('td', {
      staticClass: "el-table_3_column_28_column_33 is-center ",
      attrs: {
        "rowspan": "1",
        "colspan": "1"
      }
    }, [_c('div', {
      staticClass: "cell"
    }, [_vm._v(_vm._s(item.origin_income))])]), _vm._v(" "), _c('td', {
      staticClass: "el-table_3_column_28_column_34 is-center ",
      attrs: {
        "rowspan": "1",
        "colspan": "1"
      }
    }, [_c('div', {
      staticClass: "cell"
    }, [_vm._v(_vm._s(item.divide_per))])]), _vm._v(" "), _c('td', {
      staticClass: "el-table_3_column_28_column_35 is-center ",
      attrs: {
        "rowspan": "1",
        "colspan": "1"
      }
    }, [_c('div', {
      staticClass: "cell"
    }, [_vm._v(_vm._s(item.tax_point) + "%")])]), _vm._v(" "), _c('td', {
      staticClass: "el-table_3_column_28_column_36 is-center ",
      attrs: {
        "rowspan": "1",
        "colspan": "1"
      }
    }, [_c('div', {
      staticClass: "cell"
    }, [_vm._v(_vm._s(item.total_cost))])])]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.billList), function(item, index) {
    return (_vm.pdata.bill_type == 2) ? _c('tr', {
      staticClass: "el-table__row",
      class: index % 2 == 1 ? 'el-table__row--striped' : ''
    }, [_c('td', {
      staticClass: "el-table_3_column_28_column_29 is-center ",
      attrs: {
        "rowspan": "1",
        "colspan": "1"
      }
    }, [_c('div', {
      staticClass: "cell"
    }, [_c('span', [_vm._v(_vm._s(item.date))])])]), _vm._v(" "), _c('td', {
      staticClass: "el-table_3_column_28_column_30 is-center ",
      attrs: {
        "rowspan": "1",
        "colspan": "1"
      }
    }, [_c('div', {
      staticClass: "cell"
    }, [_vm._v(_vm._s(item.name))])]), _vm._v(" "), _c('td', {
      staticClass: "el-table_3_column_28_column_31 is-center ",
      attrs: {
        "rowspan": "1",
        "colspan": "1"
      }
    }, [_c('div', {
      staticClass: "cell"
    }, [_vm._v(_vm._s(item.appid))])]), _vm._v(" "), _c('td', {
      staticClass: "el-table_3_column_28_column_32 is-center ",
      attrs: {
        "rowspan": "1",
        "colspan": "1"
      }
    }, [_c('div', {
      staticClass: "cell"
    }, [_vm._v(_vm._s(item.origin_income))])]), _vm._v(" "), _c('td', {
      staticClass: "el-table_3_column_28_column_33 is-center ",
      attrs: {
        "rowspan": "1",
        "colspan": "1"
      }
    }, [_c('div', {
      staticClass: "cell"
    }, [_vm._v(_vm._s(item.sell_income))])]), _vm._v(" "), _c('td', {
      staticClass: "el-table_3_column_28_column_34 is-center ",
      attrs: {
        "rowspan": "1",
        "colspan": "1"
      }
    }, [_c('div', {
      staticClass: "cell"
    }, [_vm._v(_vm._s(item.export_cost))])]), _vm._v(" "), _c('td', {
      staticClass: "el-table_3_column_28_column_35 is-center ",
      attrs: {
        "rowspan": "1",
        "colspan": "1"
      }
    }, [_c('div', {
      staticClass: "cell"
    }, [_vm._v(_vm._s(item.profit))])]), _vm._v(" "), _c('td', {
      staticClass: "el-table_3_column_28_column_36 is-center ",
      attrs: {
        "rowspan": "1",
        "colspan": "1"
      }
    }, [_c('div', {
      staticClass: "cell"
    }, [_vm._v(_vm._s(item.divide_per))])]), _vm._v(" "), _c('td', {
      staticClass: "el-table_3_column_28_column_36 is-center ",
      attrs: {
        "rowspan": "1",
        "colspan": "1"
      }
    }, [_c('div', {
      staticClass: "cell"
    }, [_vm._v(_vm._s(item.tax_point) + "%")])]), _vm._v(" "), _c('td', {
      staticClass: "el-table_3_column_28_column_36 is-center ",
      attrs: {
        "rowspan": "1",
        "colspan": "1"
      }
    }, [_c('div', {
      staticClass: "cell"
    }, [_vm._v(_vm._s(item.total_cost))])])]) : _vm._e()
  }), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": _vm.pdata.bill_type == 1 ? '8' : '10'
    }
  }, [_vm._v(" ")])]), _vm._v(" "), (_vm.pdata.bill_type == 1) ? _c('tr', [_c('td', {
    staticClass: "el-table_3_column_28_column_29 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "1"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t总计\n\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_30 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "1"
    }
  }), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_31 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "1"
    }
  }), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_32 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "1"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t￥" + _vm._s(_vm.total.other_cost.toFixed(2)) + "\n\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_33 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "1"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t￥" + _vm._s(_vm.total.origin_income.toFixed(2)) + "\n\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_34 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "1"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t-\n\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_35 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "1"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t-\n\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "1"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t￥" + _vm._s(_vm.total.total_cost.toFixed(2)) + "\n\t\t\t\t\t\t\t\t\t\t\t")])]) : _vm._e(), _vm._v(" "), (_vm.pdata.bill_type == 2) ? _c('tr', [_c('td', {
    staticClass: "el-table_3_column_28_column_29 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "1"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t总计\n\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_30 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "1"
    }
  }), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_31 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "1"
    }
  }), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_32 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "1"
    }
  }), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_33 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "1"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t￥" + _vm._s(_vm.total.sell_income.toFixed(2)) + "\n\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_34 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "1"
    }
  }), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_35 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "1"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t￥" + _vm._s(_vm.total.profit.toFixed(2)) + "\n\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "1"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t-\n\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "1"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t-\n\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "1"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t￥" + _vm._s(_vm.total.total_cost.toFixed(2)) + "\n\t\t\t\t\t\t\t\t\t\t\t")])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "el-table_3_column_28_column_36 is-left ",
    staticStyle: {
      "text-align": "left",
      "padding-left": "10px"
    },
    attrs: {
      "rowspan": "1",
      "colspan": _vm.pdata.bill_type == 1 ? '8' : '10'
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.pdata.bill_type == '1' ? '结算金额 =（原生收入 * 结算比例 + 其他费用（按月）*（1 - 应扣税点））' : '结算金额=利润*结算比例*（1-税点）') + "\n\t\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _vm._l((_vm.plist), function(item) {
    return (item.remark != '' && item.remark != null) ? _c('tr', [_c('td', {
      staticClass: "el-table_3_column_28_column_36 is-left ",
      staticStyle: {
        "text-align": "left",
        "padding-left": "10px"
      },
      attrs: {
        "rowspan": "1",
        "colspan": _vm.pdata.bill_type == 1 ? '8' : '10'
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(item.remark) + "\n\t\t\t\t\t\t\t\t\t\t\t")])]) : _vm._e()
  }), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    staticStyle: {
      "color": "#f2f2f2"
    },
    attrs: {
      "rowspan": "1",
      "colspan": _vm.pdata.bill_type == 1 ? '8' : '10'
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄\n\t\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": _vm.pdata.bill_type == 1 ? '8' : '10'
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t以上金额确认无误，请盖章后寄回\n\t\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": _vm.pdata.bill_type == 1 ? '8' : '10'
    }
  }, [_vm._v(" ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "el-table_3_column_28_column_36 is-left ",
    staticStyle: {
      "text-align": "left",
      "padding-left": "10px"
    },
    attrs: {
      "rowspan": "1",
      "colspan": "4"
    }
  }, [_vm._v("公司名称 ：" + _vm._s(_vm.company.name))]), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_36 is-left ",
    staticStyle: {
      "text-align": "left",
      "padding-left": "10px"
    },
    attrs: {
      "rowspan": "1",
      "colspan": _vm.pdata.bill_type == 1 ? '4' : '6'
    }
  }, [_vm._v(_vm._s(_vm.wecompany[0]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "el-table_3_column_28_column_36 is-left ",
    staticStyle: {
      "text-align": "left",
      "padding-left": "10px"
    },
    attrs: {
      "rowspan": "1",
      "colspan": "4"
    }
  }, [_vm._v("收款银行：" + _vm._s(_vm.company.opening_bank))]), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_36 is-left ",
    staticStyle: {
      "text-align": "left",
      "padding-left": "10px"
    },
    attrs: {
      "rowspan": "1",
      "colspan": _vm.pdata.bill_type == 1 ? '4' : '6'
    }
  }, [_vm._v(_vm._s(_vm.wecompany[1]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "el-table_3_column_28_column_36 is-left ",
    staticStyle: {
      "text-align": "left",
      "padding-left": "10px"
    },
    attrs: {
      "rowspan": "1",
      "colspan": "4"
    }
  }, [_vm._v("银行账号：" + _vm._s(_vm.company.receiving_account))]), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_36 is-left ",
    staticStyle: {
      "text-align": "left",
      "padding-left": "10px"
    },
    attrs: {
      "rowspan": "1",
      "colspan": _vm.pdata.bill_type == 1 ? '4' : '6'
    }
  }, [_vm._v(_vm._s(_vm.wecompany[2]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "el-table_3_column_28_column_36 is-left ",
    staticStyle: {
      "text-align": "left",
      "padding-left": "10px"
    },
    attrs: {
      "rowspan": "1",
      "colspan": "4"
    }
  }, [_vm._v("联系人：" + _vm._s(_vm.company.contact))]), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_36 is-left ",
    staticStyle: {
      "text-align": "left",
      "padding-left": "10px"
    },
    attrs: {
      "rowspan": "1",
      "colspan": _vm.pdata.bill_type == 1 ? '4' : '6'
    }
  }, [_vm._v(_vm._s(_vm.wecompany[3]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "el-table_3_column_28_column_36 is-left ",
    staticStyle: {
      "text-align": "left",
      "padding-left": "10px"
    },
    attrs: {
      "rowspan": "1",
      "colspan": "4"
    }
  }, [_vm._v("联系电话 ：" + _vm._s(_vm.company.phone))]), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_36 is-left ",
    staticStyle: {
      "text-align": "left",
      "padding-left": "10px"
    },
    attrs: {
      "rowspan": "1",
      "colspan": _vm.pdata.bill_type == 1 ? '4' : '6'
    }
  }, [_vm._v(_vm._s(_vm.wecompany[4]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "el-table_3_column_28_column_36 is-left ",
    staticStyle: {
      "text-align": "left",
      "padding-left": "10px"
    },
    attrs: {
      "rowspan": "1",
      "colspan": "4"
    }
  }, [_vm._v("邮寄地址：" + _vm._s(_vm.company.email_addr))]), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_36 is-left ",
    staticStyle: {
      "text-align": "left",
      "padding-left": "10px"
    },
    attrs: {
      "rowspan": "1",
      "colspan": _vm.pdata.bill_type == 1 ? '4' : '6'
    }
  }, [_vm._v(_vm._s(_vm.wecompany[5]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "el-table_3_column_28_column_36 is-left ",
    staticStyle: {
      "text-align": "left",
      "padding-left": "10px"
    },
    attrs: {
      "rowspan": "1",
      "colspan": "4"
    }
  }), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_36 is-left ",
    staticStyle: {
      "text-align": "left",
      "padding-left": "10px"
    },
    attrs: {
      "rowspan": "1",
      "colspan": _vm.pdata.bill_type == 1 ? '4' : '6'
    }
  }, [_vm._v(_vm._s(_vm.wecompany[6]))])])], 2)])])])]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.tableToExcel
    }
  }, [_vm._v("导出Excel")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.handleDown
    }
  }, [_vm._v("导出pdf")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.billDialog = false
      }
    }
  }, [_vm._v("取消")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "更新日志",
      "visible": _vm.logDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.logDialog = $event
      }
    }
  }, [_c('el-table', {
    attrs: {
      "data": _vm.plog
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "username",
      "label": "操作人员",
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "create_time",
      "label": "更新时间",
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "content",
      "label": "备忘"
    }
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "备注",
      "visible": _vm.remarkDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.remarkDialog = $event
      }
    }
  }, [_c('el-form', {
    ref: "ruleForm",
    attrs: {
      "rules": _vm.remarkRules,
      "label-width": "140px"
    }
  }, [_c('el-row', {
    staticStyle: {
      "margin": "0"
    },
    attrs: {
      "gutter": 5
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "请输入备注信息",
      "prop": "ramark"
    }
  }, [_c('el-input', {
    staticClass: "w220",
    attrs: {
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.remarkForm.remark),
      callback: function($$v) {
        _vm.$set(_vm.remarkForm, "remark", $$v)
      },
      expression: "remarkForm.remark"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.remarkDialog = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveRemark
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "导入",
      "visible": _vm.batchDialog,
      "width": "650px",
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.batchDialog = $event
      }
    }
  }, [_c('el-form', {
    ref: "ruleForm",
    attrs: {
      "rules": _vm.rules,
      "label-width": "140px"
    }
  }, [(_vm.batchForm.length == 0) ? _c('el-upload', {
    staticClass: "upload-demo",
    attrs: {
      "drag": "",
      "action": _vm.url,
      "headers": _vm.headers,
      "on-success": _vm.batchSuccess,
      "name": "file",
      "show-file-list": false
    }
  }, [_c('i', {
    staticClass: "el-icon-upload"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-upload__text"
  }, [_vm._v("将文件拖到此处，或"), _c('em', [_vm._v("点击上传")])]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v("只能上传csv文件")])]) : _vm._e()], 1), _vm._v(" "), (_vm.batchForm.length > 0) ? _c('el-row', {
    staticClass: "yltt",
    attrs: {
      "gutter": 5
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_vm._v(_vm._s(_vm.batchTips == 0 ? '导入预览' : '以下数据已存在，是否覆盖'))])], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.batchForm), function(item, index) {
    return (_vm.batchForm.length > 0) ? _c('el-row', {
      key: index,
      staticClass: "yllist",
      class: 'yllist' + index,
      attrs: {
        "gutter": 5
      }
    }, _vm._l((item), function(citem, idx) {
      return _c('el-col', {
        key: idx,
        attrs: {
          "span": 6
        }
      }, [_vm._v("\n       \t\t\t\t" + _vm._s(citem) + "\n       \t\t")])
    }), 1) : _vm._e()
  }), _vm._v(" "), (_vm.batchForm.length > 0) ? _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.batchCalcel
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.batchSubmit
    }
  }, [_vm._v(_vm._s(_vm.batchTips == '0' ? '确认' : '再次确认'))])], 1) : _vm._e()], 2), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "更新日志",
      "visible": _vm.cpEditDialog,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.cpEditDialog = $event
      }
    }
  }, [_c('el-form', {
    ref: "ruleForm",
    attrs: {
      "model": _vm.editForm,
      "rules": _vm.editFormRules,
      "label-width": "220"
    }
  }, [_c('el-row', {
    staticStyle: {
      "margin": "0"
    },
    attrs: {
      "gutter": 5
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [(_vm.pdata.bill_type == 1) ? _c('el-form-item', {
    attrs: {
      "label": "其它费用（原生分成）",
      "prop": "other_cost"
    }
  }, [_c('el-input', {
    staticClass: "w220",
    attrs: {
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.editForm.other_cost),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "other_cost", $$v)
      },
      expression: "editForm.other_cost"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "原生收入",
      "prop": "origin_income"
    }
  }, [_c('el-input', {
    staticClass: "w220",
    attrs: {
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.editForm.origin_income),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "origin_income", $$v)
      },
      expression: "editForm.origin_income"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "结算比例",
      "prop": "divide_per"
    }
  }, [_c('el-input', {
    staticClass: "w220",
    attrs: {
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.editForm.divide_per),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "divide_per", $$v)
      },
      expression: "editForm.divide_per"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [(_vm.pdata.bill_type == 2) ? _c('el-form-item', {
    attrs: {
      "label": "分发收入（利润分成）",
      "prop": "sell_income"
    }
  }, [_c('el-input', {
    staticClass: "w220",
    attrs: {
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.editForm.sell_income),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "sell_income", $$v)
      },
      expression: "editForm.sell_income"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [(_vm.pdata.bill_type == 2) ? _c('el-form-item', {
    attrs: {
      "label": "导量成本（利润分成）\t",
      "prop": "export_cost"
    }
  }, [_c('el-input', {
    staticClass: "w220",
    attrs: {
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.editForm.export_cost),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "export_cost", $$v)
      },
      expression: "editForm.export_cost"
    }
  })], 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.cpEditDialog = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveCPBillData
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7a995061"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/cp/dataList.vue
// module id = 1146
// module chunks = 2